import React from 'react';
import { useTranslation } from 'react-i18next';
import './AssetLoadingScreen.css';
import LoadingBattleParade from './LoadingBattleParade';

const AssetLoadingScreen = ({ loaded = 0, total = 0 }) => {
  const { t } = useTranslation('common');

  const safeTotal = Math.max(total, 0);
  const safeLoaded = Math.min(Math.max(loaded, 0), safeTotal || 0);
  const percent = safeTotal > 0 ? Math.round((safeLoaded / safeTotal) * 100) : 0;

  return (
    <div className="asset-loading-screen" role="dialog" aria-modal="true" aria-labelledby="asset-loading-title">
      <div className="asset-loading-screen__panel">
        <LoadingBattleParade />
        <h1 id="asset-loading-title" className="asset-loading-screen__title">
          {t('assetLoadingTitle')}
        </h1>

        <div
          className="asset-loading-screen__bar"
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={safeTotal}
          aria-valuenow={safeLoaded}
          aria-label={t('assetLoadingProgress', { loaded: safeLoaded, total: safeTotal })}
        >
          <div
            className="asset-loading-screen__bar-fill"
            style={{ width: `${percent}%` }}
          />
          <div className="asset-loading-screen__bar-text">
            {t('assetLoadingProgress', { loaded: safeLoaded, total: safeTotal })}
          </div>
        </div>

        <p className="asset-loading-screen__percent">{percent}%</p>
      </div>
    </div>
  );
};

export default AssetLoadingScreen;
